import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger, DropdownMenuSeparator, DropdownMenuLabel } from "@/components/ui/dropdown-menu";
import { Bell } from "lucide-react";
import { useNotifications } from "@/context/NotificationsContext";
import { fmtDateTime } from "@/lib/format";

const NotificationBell = () => {
  const { notifications, unread, markRead, markAll } = useNotifications();
  const navigate = useNavigate();

  const open = (n) => {
    if (!n.is_read) markRead(n.notif_id);
    if (n.cta_path) navigate(n.cta_path);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" className="relative" data-testid="notif-bell-btn">
          <Bell className="w-5 h-5" />
          {unread > 0 && (
            <span className="absolute top-1 right-1 min-w-[16px] h-4 px-1 rounded-full bg-primary text-primary-foreground text-[10px] font-bold grid place-items-center">{unread}</span>
          )}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-[70vh] overflow-y-auto">
        <div className="flex items-center justify-between px-2 py-1.5">
          <DropdownMenuLabel className="p-0">Notifications</DropdownMenuLabel>
          {unread > 0 && <button onClick={markAll} className="text-xs text-primary font-medium hover:underline" data-testid="mark-all-read-btn">Mark all read</button>}
        </div>
        <DropdownMenuSeparator />
        {notifications.length === 0 ? (
          <div className="p-6 text-center text-sm text-muted-foreground">No notifications yet.</div>
        ) : (
          notifications.slice(0, 20).map((n) => (
            <div
              key={n.notif_id}
              onClick={() => open(n)}
              role={n.cta_path ? "button" : undefined}
              tabIndex={n.cta_path ? 0 : undefined}
              onKeyDown={(e) => e.key === "Enter" && open(n)}
              className={`px-3 py-2.5 border-b border-border/50 last:border-0 ${!n.is_read ? "bg-accent/40" : ""} ${n.cta_path ? "cursor-pointer hover:bg-secondary/60 transition-colors" : ""}`}
              data-testid={`notif-item-${n.notif_id}`}
            >
              <div className="flex items-start gap-2">
                {!n.is_read && <span className="w-1.5 h-1.5 mt-1.5 rounded-full bg-primary shrink-0" />}
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium">{n.title}</div>
                  <div className="text-xs text-muted-foreground mt-0.5 line-clamp-3 break-words">{n.body}</div>
                  <div className="text-[10px] text-muted-foreground mt-1">{fmtDateTime(n.created_at)}</div>
                </div>
              </div>
            </div>
          ))
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default NotificationBell;
